$(document).ready(function(){
const hash = window.location.hash;
if(hash) {
	const target = $(hash);
	if(target.length && target.next().hasClass('guideBox__body')){
		target.addClass("is_open");
		target.next(".guideBox__body").slideDown();
								setTimeout(() => {
									$('html, body').animate({
											scrollTop: target.offset().top - 100
									}, 600);
							}, 300);
	}
}
	const t = $(".guideBox__head"),
				b = $(".guideBox__body");
	t.on("click", function(){
		$(this).toggleClass("is_open");
		$(this).next(b).slideToggle();
	});
});